/* eslint-disable react-hooks/exhaustive-deps */
import { DAY_IN_MILLIS, getDateFormattedWithMillis, getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import { getMinutesOfToday, getTextByRangeMinutes } from "components/CustomTimePicker/utils";
import { EVENTS_CONSTANTS } from "config/constants";
import { useEffect, useRef, useState } from "react";
import { eventsSessionStorage } from "services/storage/events";
import useMainContext from "utils/context/useMainContext";

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const helpers = {
    checkNonExpiredOnlyDayDuration: ({ date, time }) => {
        const today = getTodayWithoutHourInMillis();
        if (date < today) 
            return `La fecha de tu evento de "${getDateFormattedWithMillis(date)}" es pasada, actualízala antes de finalizarlo por favor.`;
        if (date === today && time.start < getMinutesOfToday()) 
            return `El horario de tu evento de "${getTextByRangeMinutes(time)}" es pasado, actualízalo antes de finalizarlo por favor.`;
        return null;
    },
    findDateByTime: (date, time, today) => {
        for (let currentDateMillis = date.start; currentDateMillis <= date.end; currentDateMillis += DAY_IN_MILLIS) {
            const currentDate = new Date(currentDateMillis);
            let currentDay = currentDate.getDay();
            currentDay = currentDay === 0 ? 7 : currentDay;
            const timeFound = time.find(({ dayId }) => dayId === currentDay);
            if (!timeFound) 
                continue;
            if (currentDateMillis > today) 
                return null;
            if (timeFound.start < getMinutesOfToday()) {
                return {
                    date: currentDateMillis,
                    time: timeFound
                };
            }
        }
        return null;
    },
    checkNonExpiredManyDaysDuration: function({ date, time }) {
        const today = getTodayWithoutHourInMillis();
        if (date.start > today) 
            return null;
        const timePast = this.findDateByTime(date, time, today);
        if (timePast) 
            return `Alguno(s) horarios dentro de tu evento de "${getDateFormattedWithMillis(timePast.date)} | ${getTextByRangeMinutes(timePast.time)}" es pasado, actualízalo antes de finalizarlo por favor.` 
        return null;
    }
};
const useCheckErrorMessage = getMessage => {
    const { 
        setShowDialogUnexpectedError, 
        setDialogUnexpectedErrorMessage 
    } = useMainContext();
    function check() {
        let message = getMessage();
        if (!message)
            return true;
		setShowDialogUnexpectedError(true);
        setDialogUnexpectedErrorMessage(message);
		return false;
	}
    return check;
}

const useCheckNonExpiredDuration = ({
    form
}) => {
    const prevDurationOnlyDayRef = useRef();
    const [durationWithValue, setDurationWithValue] = useState(false);
    useEffect(() => {
        const onlyDay = form.step1.part3.duration.onlyDay;
        if (durationWithValue || !onlyDay) return;
        prevDurationOnlyDayRef.current = form.step1.part3.duration.onlyDay;
        setDurationWithValue(true);
    }, [form.step1.part3.duration.onlyDay]);
    const checkNonExpiredDuration = useCheckErrorMessage(() => {
		const { duration, period } = form.step1.part3;
        switch (period) {
            case EVENT_PERIOD_IDS.ONLY_DAY:
                const prevDurationOnlyDay = prevDurationOnlyDayRef.current;
                if (prevDurationOnlyDay.date === duration.onlyDay.date && 
                    prevDurationOnlyDay.time.start === duration.onlyDay.time.start && 
                    prevDurationOnlyDay.time.end === duration.onlyDay.time.end)
                    return null;
                prevDurationOnlyDayRef.current = duration.onlyDay;
                return helpers.checkNonExpiredOnlyDayDuration(duration.onlyDay);
            case EVENT_PERIOD_IDS.MANY_DAYS:
                const isDraft = eventsSessionStorage.isDraftEvent.get();
                if (!isDraft)
                    return null;
                return helpers.checkNonExpiredManyDaysDuration(duration.manyDays);
            default: 
                return "No has seleccionado un período, debes hacerlo para establecer la duración del evento.";
        }
	});
    return checkNonExpiredDuration;
}
export const useCheckNonExpiredOnlyDayDuration = ({ duration, editionStarted }) => {
    const prevDurationRef = useRef();
    const [durationWithValue, setDurationWithValue] = useState(false);
    useEffect(() => {
        if (!editionStarted) 
            setDurationWithValue(false);
    }, [editionStarted]);
    useEffect(() => {
        if (!duration || durationWithValue || !editionStarted) return;
        prevDurationRef.current = duration;
        setDurationWithValue(true);
    }, [duration]);
    const checkNonExpiredDuration = useCheckErrorMessage(() => {
        const prevDuration = prevDurationRef.current;
        if (prevDuration.date === duration.date && 
            prevDuration.time.start === duration.time.start && 
            prevDuration.time.end === duration.time.end)
            return null;
        prevDurationRef.current = duration;
        return helpers.checkNonExpiredOnlyDayDuration(duration)
    });
    return checkNonExpiredDuration;
}

export default useCheckNonExpiredDuration;